<script lang="ts">
  import { onMount, onDestroy } from 'svelte';

  export let copy: string;
  export let items: {key: string, value: string}[];
  export let onSelect: (item: string) => void;
  export let isSecondary: boolean = false;
  export let dropUp: boolean = false;

  let isPanelVisible = false;
  let dropdownElement: HTMLElement;

  const togglePanel = (evt: MouseEvent) => {
    evt.stopPropagation();
    isPanelVisible = !isPanelVisible;
  };

  const hidePanel = (evt: MouseEvent) => {
    evt.stopPropagation();
    isPanelVisible = false;
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (dropdownElement && !dropdownElement.contains(event.target as Node)) {
      isPanelVisible = false;
    }
  };

  onMount(() => {
    document.addEventListener('click', handleClickOutside);
  });

  onDestroy(() => {
    document.removeEventListener('click', handleClickOutside);
  });
</script>

{#if isSecondary}
  <div class="std-dropdown std-dropdown--secondary inline-flex relative mx-2.5" class:active={isPanelVisible} bind:this={dropdownElement}>
    <a href="/" on:click|preventDefault={togglePanel} class="std-dropdown__button font-MrEavesXLSanNarOTUltra relative bg-dark flex text-[16px] h-[48px] mr-[46px] px-[15px] text-white font-medium items-center justify-center border-solid border-2 z-[1] uppercase transition-[border] laptop:text-[20px] desktop:h-[60px] desktop:mr-[58px] desktop:text-[24px] desktopLg:h-[68px] desktopLg:text-[26px]">
      {@html copy}
      <div class="std-dropdown__button-arrow absolute flex items-center justify-center w-[48px] h-[48px] left-[100%] border-solid border-white border-2 desktop:h-[60px] desktop:w-[60px] desktopLg:h-[68px] desktopLg:w-64px">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 335.877 196.929">
          <path d="M306.885 0 167.938 138.947 28.991 0 0 28.991l167.938 167.938L335.877 28.991 306.885 0z" fill="currentColor" />
        </svg>
      </div>
    </a>
    <div
      class={`
        std-dropdown__panel absolute left-0 w-calc-100-minus-48 top-full bg-dark z-[150] border-solid border-white
        border-x-2 border-b-2 translate-y-20px invisible opacity-0 transition desktop:w-calc-100-minus-60
        desktopLg:w-calc-100-minus-64 ${dropUp ? 'tablet:bottom-full tablet:top-auto' : ''}
      `}>
      <div class="border-solid border-t border-solid border-white">
        {#each items as item, index}
          <div class="border-solid" class:border-b-2={index < items.length - 1}>
            <a href="/" on:click|preventDefault={() => onSelect(item.key)} class="std-dropdown__link relative">
              <span class="std-dropdown__text relative z-[1]">{item.value}</span>
            </a>
          </div>
        {/each}
      </div>
    </div>
  </div>
{:else}
  <div class="std-dropdown relative mx-0 tabletLg:mx-2.5 w-full mb-[56px] tabletLg:w-auto tabletLg:mb-0" class:active={isPanelVisible} bind:this={dropdownElement}>
    <a href="/" on:click|preventDefault={togglePanel} class="std-dropdown__button relative w-full flex text-[15px] h-[32px] px-[8px] text-white font-medium items-center justify-center font-roboto border-solid border-white bg-transparent z-[1] uppercase transition-[border] tabletLg:border-transparent tabletLg:w-auto tabletLg:border-x tabletLg:border-t text-center">
      {@html copy}
      <div class="std-dropdown__button-arrow w-[18px] ml-[8px] hidden tabletLg:block">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 335.877 196.929">
          <path d="M306.885 0 167.938 138.947 28.991 0 0 28.991l167.938 167.938L335.877 28.991 306.885 0z" fill="currentColor" />
        </svg>
      </div>
    </a>
    <div class="std-dropdown__panel relative p-[8px] right-0 w-full top-0 bg-dark z-[150] border-solid border-white translate-y-0 visible opacity-100 transition tabletLg:absolute tabletLg:opacity-0 tabletLg:invisible tabletLg:top-full tabletLg:translate-y-20px tabletLg:border-x tabletLg:border-b">
      <div class="text-center border-solid border-t border-solid border-white tabletLg:text-left">
        {#each items as item, index}
          <div class="my-[8px]" class:mb-0={index === items.length - 1}>
            <a href="/" on:click|preventDefault={() => onSelect(item.key)} class="std-dropdown__link text-[16px] text-white font-medium uppercase transition-[color] hover:text-primary">
              {item.value}
            </a>
          </div>
        {/each}
      </div>
    </div>
  </div>
{/if}
